import { isEmailAddressValid } from "../../../utils/Utilities"

export const validateClientName = (firstName, lastName, updatedFormErrorList) => {
    if(!(firstName && firstName.trim())) {
        updatedFormErrorList.push("First Name is required.")
    }

    if(!(lastName && lastName.trim())) {
        updatedFormErrorList.push("Last Name is required.")
    }
}

export const validateEmailAddress = (emailAddress, updatedFormErrorList) => {
    let noEmailAddressList = ["none", "n/a", "na"]
    let hasNoEmailAddress = noEmailAddressList.includes(emailAddress?.trim().toLowerCase())

    if(emailAddress && emailAddress.trim() && !hasNoEmailAddress && !isEmailAddressValid(emailAddress)) {
        updatedFormErrorList.push("Email Address format is incorrect.")
    }
}

export const validatePrimaryAddress = (primaryAddress, updatedFormErrorList) => {
    if(primaryAddress && primaryAddress.toLowerCase().includes("po box")) {
        updatedFormErrorList.push("A physical address is required for the primary address. Please enter the PO Box under mailing address.")
    }
}